import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom'; 

const Videos = () => {
    const { listingId } = useParams();
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('listing_id', listingId);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.videoList}`,
                    data: formData
                });
            
                if (response.data.items && Array.isArray(response.data.items)) {
                    setListings(response.data.items);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchListings();
    }, []);

    const faqs = [
        {
            question: "What is Lorem Ipsum?",
            answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        },
        {
            question: "Where does it come from?",
            answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
        },
    ];
    
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Videos</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='row'>
                <div className='col-md-8'>
                    <div className='yl-header'>
                        <div>
                            <img src='/assets/img/banners/vibe_video_banner.png' alt='' className='img-fluid' />
                        </div>
                    </div>

                    <div className='advd-btn'>
                        <a href={`/add-video/${listingId}`}>Add Vibes Video</a>
                    </div>

                    {listings.length > 0 ? (
                        <div className='row'>
                            {listings.map((listing) => (
                                <div className='col-md-4 lb mb-3' key={listing.id_tag_id}>
                                    <div>
                                        <div className='acc-box' style={{marginBottom:'10px'}}>
                                            <div className="apimgcibox">
                                                <div className='lcibox'>
                                                    <div className='listing-cover-image mb-0'>
                                                        <video className="ciso img-fluid" controls>
                                                            <source src={listing.video_origin} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='co-host-box'>
                                            <span className='acc-btn-txt'>{listing.video_status_text}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="empty-chat-section ems">
                            <img src={'/assets/img/placeholder/no_vibe_video_uploaded.svg'} className='empty-image img-fluid' alt='' />
                        </div>
                    )}
                </div>
                <div className='col-md-4 p-0'>
                    <div className='bfhsd'>
                        <div className='blog-box'>
                            <div class="blog">
                                <div class="blog-image">
                                    <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                                    <div class="date">May 08, 2025</div>
                                </div>
                                <div class="blog-content">
                                    <h2>What is Lorem Ipsum?</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                                    <a href="#">Read More</a>
                                </div>
                            </div>
                        </div>
                        <div className="faq-sticky">
                            {faqs.map((faq, index) => (
                            <div key={index} className='faqs-list-section'>
                                <div
                                onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                                style={{
                                    backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                                }}
                                >
                                {faq.question}
                                <i
                                    className={`fas ${
                                    activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                                    }`}
                                    style={{
                                    transition: "transform 0.3s ease",
                                    }}
                                ></i>
                                </div>
                                {activeIndex === index && (
                                <div className='faqs-ans-box'>
                                    {faq.answer}
                                </div>
                                )}
                            </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Videos;
